export const PRIZM_ASSETS_FOLDER = '/assets/prizm-ui/components';
export const PRIZM_ASSETS_FONT_FOLDER = '/assets/prizm-ui/fonts';
